@if (!cookiesEnabled()) {
  <div class="bg-red-200">
    <h2 class="text-center text-2xl font-semibold font-mulish mx-12">Cookies are disabled</h2>

    <p class="text-center text-gray-600 mt-4 md:mt-6 text-lg font-mulish">
        Same-Site cookies are disabled in your browser, so this page might not function correctly.<br>Please enable cookies to sign in.
    </p>
  </div>
}
